import { configureStore } from '@reduxjs/toolkit';
import reducer from './actions';
import { theatresSlice } from './features/theatresDetails';
import { cplApiSlice } from './features/compositions';
import { movieSlice } from './features/movies';
import { usersSlice } from './features/users';
import { suiteLogsApi } from './features/suiteLogs';

export const store = configureStore({
  reducer: reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      theatresSlice.middleware,
      cplApiSlice.middleware,
      movieSlice.middleware,
      usersSlice.middleware,
      suiteLogsApi.middleware,
    ),
  devTools: true,
});

export default store;
